import { Observable, of as observableOf, Subject } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ObservableStorage } from './observable-storage';
import { OrdersOverview, Order, RecommendationRenderModel } from '../models/order';

export class OrderStorage extends ObservableStorage<OrdersOverview> {
	constructor() {
		super('orders', localStorage);
	}
	updateOpenedOrders(openedOrders: Order[]): Observable<OrdersOverview> {
		return super.get().pipe(
			mergeMap(orders => {
				orders = orders || this._emptyModel();
				orders.openedOrders = openedOrders;
				orders.openedOrdersLastUpdated = Date.now();
				super.set(orders);
				return observableOf(orders);
			})
		);
	}
	updateArchivedOrders(archivedOrders: Order[]): Observable<OrdersOverview> {
		return super.get().pipe(
			mergeMap(orders => {
				orders = orders || this._emptyModel();
				orders.archivedOrders = archivedOrders;
				orders.archivedOrdersLastUpdated = Date.now();
				super.set(orders);
				return observableOf(orders);
			})
		);
	}
	updateRecommandations(recommandations: RecommendationRenderModel[]): Observable<OrdersOverview> {
		return super.get().pipe(
			mergeMap(orders => {
				orders = orders || this._emptyModel();
				orders.recommandations = recommandations;
				orders.recommandationsLastUpdated = Date.now();
				super.set(orders);
				return observableOf(orders);
			})
		);
	}
	getOpenedOrders(): Observable<Order[]> {
		return super.get().pipe(
			mergeMap(orders => {
				let openedOrders = null;
				if (orders !== null && orders.openedOrders !== undefined && orders.openedOrders !== null) {
					if (this.isOutdated(orders.openedOrdersLastUpdated) === false) {
						openedOrders = orders.openedOrders;
					}
				}
				return observableOf(openedOrders);
			})
		);
	}
	getArchivedOrders(): Observable<Order[]> {
		return super.get().pipe(
			mergeMap(orders => {
				let archivedOrders = null;
				if (orders !== null && orders.archivedOrders !== undefined && orders.archivedOrders !== null) {
					if (this.isOutdated(orders.archivedOrdersLastUpdated) === false) {
						archivedOrders = orders.archivedOrders;
					}
				}
				return observableOf(archivedOrders);
			})
		);
	}
	getRecommandations(): Observable<RecommendationRenderModel[]> {
		return super.get().pipe(
			mergeMap(orders => {
				let recommandations = null;
				if (orders !== null && orders.recommandations !== undefined && orders.recommandations !== null) {
					if (this.isOutdated(orders.recommandationsLastUpdated) === false) {
						recommandations = orders.recommandations;
					}
				}
				return observableOf(recommandations);
			})
		);
	}

	clearOrders(): Observable<OrdersOverview> {
		const orders = this._emptyModel();
		super.set(orders);
		return observableOf(orders);
	}

	private _emptyModel(): OrdersOverview {
		return {
			openedOrders: null,
			openedOrdersLastUpdated: 0,
			archivedOrders: null,
			archivedOrdersLastUpdated: 0,
			recommandations: null,
			recommandationsLastUpdated: 0
		};
	}

	private isOutdated(lastUpdated: number) {
		return lastUpdated < 1 || Math.floor((Date.now() - lastUpdated) / 1000) > 3600;
	}
}
